/* eslint-disable react-hooks/rules-of-hooks */
import { observer } from "mobx-react";
import { Button, createStyles, Flex, Text } from "@mantine/core";
import { useCallback } from "react";
import { useStore } from "../../../hooks/use-store";
import ImageObserved from "./Image";
import { MODE_2 } from "../../../stores/data/space-store/space-store";
import { useHistory } from "react-router-dom";
export type GalleryItem = {
  images: { url: string, preview: string }[];
  previewHdrl: string;
  enhancedHdrlFile: string;
  modelVersion?: string;
  loraName?: string;
}

const useStyles = createStyles((theme) => ({
  cardItem: {
    cursor: "pointer",
  },
  card: {
    border: '1px solid rgba(70, 70, 70, 1)'
  },
  cardTitle: {
    fontWeight: 700,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    lineHeight: 1.2,
  },
  body: {
    padding: theme.spacing.md,
    background: 'rgba(16, 16, 16, 1)',
  },
  wrapper: {
    maxWidth: "100%",
    width: "100%",
    padding: '0 1rem',
  },
  title: {
    marginBottom: theme.spacing.sm,
    paddingLeft: theme.spacing.sm,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
  },
  item: {
    fontSize: theme.fontSizes.sm,
    color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
  },
  center: {
    display: "flex",
    justifyContent: "center",
  },
  video: {
    margin: "0 auto",
    "> div": {
      position: "absolute!important" as any,
      transformOrigin: "left top",
      borderRadius: "8px",
      overflow: "hidden",
    },
  },
  imageContainer: {
    position: 'relative',
    cursor: 'pointer',
    borderRadius: '8px',
    overflow: 'hidden',
    '&:hover .selectButton': {
      opacity: 1,
    },
    '&:hover .imageOverlay': {
      opacity: 0.7,
    },
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  selectButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 0,
    transition: 'opacity 0.2s',
    zIndex: 11,
    background: '#f53c02',
    '&:hover': {
      background: '#e03500',
    },
  },
  imageGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '6px',
    padding: '16px',
  },
  popoverFlex: {
    // padding: '6px 8px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(32, 32, 32, 1)',
      borderRadius: '4px',
    },
  },
}));

const Element = () => {
  const { classes } = useStyles();

  const history = useHistory()
  const {
    dataStore: { spaceStore },
    uiStore: { authStore },
  } = useStore();

  const secretModeEnabled = authStore.currentUser?.id === 'user_ncW1SxIG5X3mwQGtmPp5Z' || authStore.currentUser?.id === 'user_ztvePOlS8Ylq0N0c5wFhK' || authStore.currentUser?.id === 'user_RzgcIMD1nu3VgXxx1ohCx' || authStore.currentUser?.id === 'user_bwxZh45ttxCf6U3MQeJCc'
  const veit = authStore.currentUser?.id === 'user_Bj-uUfbHhVh-KMkcTjVeE'
  const images = [
    'https://cdn.maground.ai/eu/workspace/ma-CSC_1715_1_163093_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_2063_1_204279_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_2074_1_204356_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_2296_1_214003_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3032_1_264020_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3282_1_291240_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3333_1_291610_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3349_1_291734_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3530_1_361496_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3541_1_361562_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3565_1_364721_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3566_1_364727_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3568_1_364745_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3739_1_584494_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3784_1_650100_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3795_1_650183_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_3979_1_728038_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_634_1_93975_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-CSC_914_1_116747_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-ELI_360_1_105548_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBE_819_1_348318_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBE_839_1_348533_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBE_841_1_348549_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBE_989_1_358084_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBO_192_1_96019_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBO_2504_1_339586_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-JBO_2954_1_400046_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-LZI_385_1_84494_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-LZI_641_1_179381_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_11767_1_577946_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_11821_1_578427_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_12058_1_590668_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_12060_1_590678_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_12062_1_590689_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_2224_1_157624_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_2950_1_180027_L.jpg',  
'https://cdn.maground.ai/eu/workspace/ma-MAG_2989_1_180602_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_3088_1_183736_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_3112_1_183962_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_4797_1_244575_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_6746_1_329100_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_6753_1_329189_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_6754_1_329196_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_8375_1_427952_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_8421_1_428252_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_8427_1_428308_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_8428_1_428314_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_8436_1_428347_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAG_9602_1_490236_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAL_293_1_651619_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MAX_2233_1_424512_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_2383_1_150219_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_2406_1_150454_L.jpg',      
'https://cdn.maground.ai/eu/workspace/ma-MHA_2602_1_152500_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_2606_1_152549_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_4276_1_425781_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_4282_1_425857_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_4291_1_425972_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MHA_4293_1_426003_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MJU_58_1_441304_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MLT_1828_1_661508_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MLT_1830_1_661537_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-MWE_173_1_80388_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-PHA_177_1_380007_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-PHA_1984_1_594308_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-PHA_2145_1_595642_L.jpg',    
'https://cdn.maground.ai/eu/workspace/ma-PHA_902_1_491363_L.jpg', 
'https://cdn.maground.ai/eu/workspace/ma-PSC_1030_1_634564_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-PSC_54_1_114589_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-RGA_15_1_660641_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-RNA_1256_1_420877_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-RNA_1258_1_420889_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-RNA_2496_1_491846_L.jpg',  
'https://cdn.maground.ai/eu/workspace/ma-RNA_5631_1_613030_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-SAR_190_1_593832_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-SAR_76_1_589860_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-STC_214_1_656404_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-STC_248_1_657498_L.jpg',
'https://cdn.maground.ai/eu/workspace/ma-STC_287_1_672988_L.jpg',
  ]

  const handleStartWithLocation = useCallback((imageUrl: string) => {
    spaceStore.setMode2(MODE_2.WORKSPACE_AIRETOUCH);
    spaceStore.setSelectedImage({ src: imageUrl });
    history.push('/generate');
  }, [history, spaceStore]);

  if (!secretModeEnabled && !veit) {
    return (
      <Flex w="100%" justify="center" align="center" mt={120}>
        <Text fz={18} c="white">
          Workspace is only available for internal testing right now.
        </Text>
      </Flex>
    );
  }

  return (
    <Flex w="100%" justify="center" gap={8} mt={20} mb={60} className={classes.wrapper}>
      <Flex direction="column" w="100%" gap={24}>
        <Text fz={24} fw={700} c="white" px="sm">
          Pick a MAGROUND location to start.
        </Text>
        <div className={classes.imageGrid}>
          {images.map((imageUrl) => (
            <div
              key={imageUrl}
              className={`${classes.imageContainer} imageContainer`}
              onClick={() => handleStartWithLocation(imageUrl)}
            >
              <div className={`${classes.imageOverlay} imageOverlay`} />
              <ImageObserved
                width="100%"
                height="220"
                src={imageUrl}
                objectFit="cover"
                imgStyle={{  objectFit: 'cover' }}
                // style={{ objectFit: 'cover' }}
              />
              <Button
                className={`${classes.selectButton} selectButton`}
                variant="filled"
                color="orange"
                size="sm"
                onClick={(event) => {
                  event.stopPropagation();
                  handleStartWithLocation(imageUrl);
                }}
              >
                Start with this location
              </Button>
            </div>
          ))}
        </div>
      </Flex>
    </Flex>
  );
};

export const Workspace = observer(Element);